import lottie from 'lottie-web';
import React, { useEffect, useState } from 'react';
import { HideUntilLoaded } from 'react-animation';
import { useStore } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import AgendaService from '../services/AgendaService';
import CampanhaService from '../services/CampanhaService';
import TemaService from '../services/TemaService';
function MissaoCumprida() {

    const i18n = useStore().getState().i18n; 
    const agendaService = new AgendaService()
    const history = useHistory()
    let {atividade} = useParams()
    let {codigoAgenda, codigoAtividade} = useParams()
    const [erro, setErro] = useState(null)
    const [processando, setProcessando] = useState(false)
    const [informacoes, setInformacoes] = useState({textoPontuacao: "", trofeu: ""})

    useEffect(() => {
        let campanhaService = new CampanhaService();
        let temaService = new TemaService(campanhaService.campanhaCorrente())
        temaService.aplicarTema('MISSAO')
        if(!processando){
            setProcessando(true)
            agendaService.agendaCorrente((erro, agenda) => {
                if(agenda){
                    lottie.loadAnimation({
                        container: document.getElementById("missao-cumprida-container-confetes"), 
                        renderer: 'svg',
                        loop: true,
                        autoplay: true,
                        path: '/confete.json' 
                    });
                    lottie.loadAnimation({
                        container: document.getElementById("missao-cumprida-container-palmas"), 
                        renderer: 'svg',
                        loop: true,
                        autoplay: true,
                        path: '/palmas.json' 
                    });
                    for(let i = 0; i < agenda.schedule.length; i++){
                        if(agenda.schedule[i].scheduleCode == codigoAgenda){
                            for(let j = 0; j < agenda.schedule[i].activities.length; j++){
                                if(agenda.schedule[i].activities[j].type === atividade  && agenda.schedule[i].activities[j].uuid === codigoAtividade){
                                    let info = {}
                                    if(atividade === "FACT_OR_FAKE"){
                                        let acertos = agenda.schedule[i].activities[j].acertos
                                        let perguntas = agenda.schedule[i].activities[j].numeroQuestoes
                                        info.textoPontuacao = <div className="pontuacao">{i18n.message("missaoCumprida.pontuacao.perguntas.inicio", "Você acertou")} <span className="pontuacao__destaque foreground">{acertos} {i18n.message("missaoCumprida.pontuacao.perguntas.de", "de")} {perguntas} ({(100*( (acertos/perguntas).toFixed(2) ))}%)</span> {i18n.message("missaoCumprida.pontuacao.perguntas.final", "das perguntas.")}</div>
                                    }
                                    info.trofeu = agenda.schedule[i].activities[j].trophyEnabled
                                    setInformacoes(info)
                                    break
                                }
                            }
                            break
                        }
                    }
                }
                if(erro){
                    history.push("/")
                }
            })
        }
    }, []);

    function navegarTrofeus(){
        history.push("/trophy")
    }

    function voltar(){
        if (atividade === 'GAME') {
            window.location = localStorage.getItem('ultimoGame')
            return
        }
        history.goBack()
    }

    const css = {
        width: "100%"
    };

    return (
        <div>
            <div id="missao-cumprida-container-confetes" className="missao-cumprida-container-confetes foreground"></div>
            <div className="titulo-container">
                <h1 className="title title__missao-cumprida foreground">{i18n.message("missaoCumprida.fim", "MISSÃO CUMPRIDA!")}</h1>
                <h2 className="subtitle subtitle__missao-cumprida foreground">{i18n.message("missaoCumprida.parabens", "Parabéns pela participação!")}</h2>
            </div>
            <div className="pontuacao-container foreground">
                {atividade ? (
                    <div>
                        {informacoes.textoPontuacao}
                    </div>
                ) : (null)}
            </div>
            <button className="weex-button weex-botao-confirmacao weex-botao-confirmacao__texto-comprido__missao-cumprida mb-4" onClick={navegarTrofeus}>
                {i18n.message("missaoCumprida.trofeus", "CONFIRA A SUA SALA DE TROFÉUS")}
            </button>
            {
            (<button className="weex-button weex-botao-confirmacao weex-botao-confirmacao__texto-comprido__missao-cumprida" onClick={voltar}>
                {i18n.message("missaoCumprida.repetir", "Repetir ação")}
            </button>)
            }
            <div className="efeitoZoomInOut my-4">
                {informacoes.trofeu ? (
                    <HideUntilLoaded style={css}>
                        <img src={informacoes.trofeu} alt={"Troféu " + atividade} className="trofeu"></img>                
                    </HideUntilLoaded>
                ) : (null)}
            </div>
            <div id="missao-cumprida-container-palmas" className="missao-cumprida-container-palmas"></div>
        </div>
    )
}

export default MissaoCumprida;